import { b as __assign, a as __spreadArray, _ as __read } from '../../../tslib.es6-fe064bda.js';
import '../enums/GameSpecificTypes.js';
import '../enums/MaxPayoutDataTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import { BetStatus } from '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/TimeoutMaxValue.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import '../enums/DefaultQueryValues.js';
import '../enums/FreeBetWinningType.js';
import '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/RequestStatus.js';
import '../enums/FetchDefaultPaths.js';
import { BetResponseCode } from '../enums/ResponseCodes.js';
import { BOG_LINE_GAME_TYPES } from '../enums/BogLineGameConfigs.js';
import { t as toFixed, a as plus } from '../../../environmentBuilder-f5cc0440.js';
import 'mobx';
import '../classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../services/liveConnection/types.js';
import '../store/chatStore.js';
import '../store/gameResultStore.js';
import '../enums/BogLineGameConfig.js';
import './parseQuery.js';
import '../store/wageringStore.js';
import 'axios';
import '../store/roundInfoStore.js';
import '../store/userCountStore.js';
import '../enums/StatisticsSortingTypes.js';
import '../services/sound/types.js';
import '../services/sound/SoundService.js';
import 'howler';
import '../services/sound/defaultSounds.js';
import '../services/api/types.js';
import '../services/api/BaseApiService.js';
import '../store/resultHashStore.js';
import '../store/userWinBetsStore.js';
import '../store/notificationStore.js';
import '../store/selectedResultInfoStore.js';
import '../services/ApiServices.js';
import '../polyfill.js';
import '../../../_commonjsHelpers-1a7a244d.js';
import '../../../momentFormat-14fce7b4.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import './formatDate.js';
import './isMobile.js';
import '../enums/bogGameNames.js';
import './updateHalfBets.js';

var currentIndex = 0;
var currentOdd = 1;
var callFakeGameSocketHandlersWithRoundFinAndStart = function (_a) {
    var betData = _a.betData, handleCashOut = _a.handleCashOut, handleRoundFin = _a.handleRoundFin, handleResultReport = _a.handleResultReport, handleDoBetResult = _a.handleDoBetResult, finishedResultReportData = _a.finishedResultReportData;
    var additionalParams = betData.additionalParams;
    setTimeout(function () {
        handleDoBetResult(__assign(__assign({}, betData), { betData: additionalParams, status: BetStatus.Pending, winAmount: 0, responseCode: BetResponseCode.Success }));
    }, 3000);
    var interval = setInterval(function () {
        if (currentIndex < finishedResultReportData.length) {
            var currentData = finishedResultReportData.slice(0, currentIndex + 1);
            handleResultReport({ data: { resultReportData: currentData } });
            if ((additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.cashOutStep) - (additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.betStep) === currentIndex &&
                currentIndex != (betData === null || betData === void 0 ? void 0 : betData.roundData.length) - (additionalParams === null || additionalParams === void 0 ? void 0 : additionalParams.betStep)) {
                handleCashOut(betData);
            }
            currentIndex++;
        }
        else {
            clearInterval(interval);
            handleRoundFin({ data: { finishedRound: null } });
            currentIndex = 0;
        }
    }, 3500);
};
var callFakeGameSocketHandlersWithMarketGames = function (_a) {
    var betData = _a.betData, handleBetsClosed = _a.handleBetsClosed, handleDoBetResult = _a.handleDoBetResult, handleRoundFin = _a.handleRoundFin, socketEventsHandlerDelays = _a.socketEventsHandlerDelays;
    var additionalParams = betData.additionalParams;
    var _b = socketEventsHandlerDelays || {}, handleBetsClosedDelay = _b.handleBetsClosed, handleDoBetResultDelay = _b.handleDoBetResult, handleRoundFinDelay = _b.handleRoundFin;
    setTimeout(function () {
        setTimeout(function () {
            return handleDoBetResult(__assign(__assign({}, betData), { betData: additionalParams, status: BetStatus.Pending, winAmount: 0, responseCode: BetResponseCode.Success }));
        }, handleDoBetResultDelay || 200);
        setTimeout(function () { return handleBetsClosed(); }, handleBetsClosedDelay || 1000);
        setTimeout(function () { return handleRoundFin({ data: { bets: [betData], finishedRound: { roundData: betData === null || betData === void 0 ? void 0 : betData.roundData } } }); }, handleRoundFinDelay || 1500);
    }, 1500);
};
var callFakeGameSocketHandlersForBogLineTurboGames = function (_a) {
    var betData = _a.betData, handleDoBetResult = _a.handleDoBetResult, handleLiveBetsResult = _a.handleLiveBetsResult, socketEventsHandlerDelays = _a.socketEventsHandlerDelays;
    var _b = socketEventsHandlerDelays || {}, handleDoBetResultDelay = _b.handleDoBetResult, handleLiveBetsResultDelay = _b.handleLiveBetsResult;
    setTimeout(function () {
        setTimeout(function () {
            return handleDoBetResult({
                betResult: __assign(__assign({}, betData), { betData: __assign({}, betData === null || betData === void 0 ? void 0 : betData.additionalParams) }),
                finishedRound: { roundData: betData === null || betData === void 0 ? void 0 : betData.roundData },
            });
        }, handleDoBetResultDelay || 1500);
        setTimeout(function () { return handleLiveBetsResult(betData); }, handleLiveBetsResultDelay || 1500);
    }, 2000);
};
var callFakeGameSocketHandlersForCrashGame = function (_a) {
    var betData = _a.betData, gameType = _a.gameType, handleBetsClosed = _a.handleBetsClosed, handleRoundStart = _a.handleRoundStart, handleDoBetResult = _a.handleDoBetResult, handleCashOutResult = _a.handleCashOutResult, handleResultReport = _a.handleResultReport, handleRoundFin = _a.handleRoundFin, socketEventsHandlerDelays = _a.socketEventsHandlerDelays;
    var betClosedTime = 0;
    var roundStartTime = 0;
    var additionalParams = betData.additionalParams, _b = betData.gameTypeId, gameTypeId = _b === void 0 ? null : _b;
    var _c = socketEventsHandlerDelays || {}, handleBetsClosedDelay = _c.handleBetsClosed, handleRoundStartDelay = _c.handleRoundStart, handleDoBetResultDelay = _c.handleDoBetResult, handleResultReportDelay = _c.handleResultReport, handleRoundFinDelay = _c.handleRoundFin;
    if ([BOG_LINE_GAME_TYPES.ONLY_CRASH, BOG_LINE_GAME_TYPES.MARKET_AND_CRASH].includes(gameType)) {
        setTimeout(function () {
            setTimeout(function () { return handleRoundStart({ data: { startedRound: { roundId: betData === null || betData === void 0 ? void 0 : betData.roundId, duration: 5, gameTypeId: gameTypeId } } }); }, handleRoundStartDelay || 400);
            setTimeout(function () {
                handleDoBetResult(__assign(__assign({}, betData), { betData: additionalParams, status: BetStatus.Pending, winAmount: 0, responseCode: BetResponseCode.Success }));
            }, handleDoBetResultDelay || 500);
            setTimeout(function () {
                betClosedTime = Date.now();
                handleBetsClosed();
            }, handleBetsClosedDelay || 800);
            var _a = additionalParams.cashOutInfos, cashOutInfos = _a === void 0 ? null : _a;
            setTimeout(function () {
                var intervalId = setInterval(function () {
                    var _a, _b, _c, _d, _e;
                    roundStartTime = roundStartTime ? roundStartTime : Date.now();
                    var odd = toFixed(plus(currentOdd, 0.01), 2);
                    if (+odd <= (+((_a = betData === null || betData === void 0 ? void 0 : betData.roundData) === null || _a === void 0 ? void 0 : _a.odd) || +(betData === null || betData === void 0 ? void 0 : betData.roundData))) {
                        currentOdd = odd;
                        if (cashOutInfos && (cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos.length)) {
                            var isFullCashOutedBetWithHalf = (cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos.length) === 2;
                            var onlyHalfCashOutedBet = (cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos.length) === 1;
                            if (isFullCashOutedBetWithHalf) {
                                if (+odd === +((_b = cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos[0]) === null || _b === void 0 ? void 0 : _b.odd)) {
                                    handleCashOutResult(__assign(__assign(__assign({}, betData), cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos[0]), { additionalParams: __assign(__assign({}, betData === null || betData === void 0 ? void 0 : betData.additionalParams), { cashOutInfos: [__assign({}, cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos[0])] }), cashOutHalf: true, status: BetStatus.Pending }));
                                }
                                else if (+odd === +((_c = cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos[1]) === null || _c === void 0 ? void 0 : _c.odd))
                                    handleCashOutResult(__assign(__assign(__assign({}, betData), cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos[1]), { additionalParams: __assign({}, betData === null || betData === void 0 ? void 0 : betData.additionalParams), cashOutHalf: false }));
                            }
                            if (onlyHalfCashOutedBet) {
                                if (+odd === +((_d = cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos[0]) === null || _d === void 0 ? void 0 : _d.odd)) {
                                    handleCashOutResult(__assign(__assign(__assign(__assign({}, betData), { additionalParams: __assign(__assign({}, betData === null || betData === void 0 ? void 0 : betData.additionalParams), { cashOutInfos: [__assign({}, cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos[0])] }) }), cashOutInfos === null || cashOutInfos === void 0 ? void 0 : cashOutInfos[0]), { cashOutHalf: true, status: BetStatus.Pending }));
                                }
                            }
                        }
                        else {
                            if (+odd === +(betData === null || betData === void 0 ? void 0 : betData.odd)) {
                                handleCashOutResult(betData);
                            }
                        }
                        handleResultReport({
                            data: {
                                resultReportData: { odd: odd, bets: null, second: betClosedTime - roundStartTime },
                                gameTypeId: gameTypeId,
                                isCrash: +odd >= (+((_e = betData === null || betData === void 0 ? void 0 : betData.roundData) === null || _e === void 0 ? void 0 : _e.odd) || (betData === null || betData === void 0 ? void 0 : betData.roundData)),
                            },
                        });
                    }
                    else {
                        clearInterval(intervalId);
                        setTimeout(function () {
                            handleRoundFin({
                                data: {
                                    finishedRound: { roundData: betData === null || betData === void 0 ? void 0 : betData.roundData, gameTypeId: gameTypeId },
                                    bets: gameType === BOG_LINE_GAME_TYPES.MARKET_AND_CRASH ? [betData] : [],
                                },
                            });
                        }, handleRoundFinDelay || 0);
                    }
                }, 100);
            }, handleResultReportDelay || 1500);
        }, 2500);
    }
};
var callFakeGameSocketHandlersForSeveralTheSameBets = function (_a) {
    var betData = _a.betData, handleBetsClosed = _a.handleBetsClosed, handleRoundStart = _a.handleRoundStart, handleDoBetResult = _a.handleDoBetResult, handleCashOutResult = _a.handleCashOutResult, handleResultReport = _a.handleResultReport, handleRoundFin = _a.handleRoundFin, socketEventsHandlerDelays = _a.socketEventsHandlerDelays;
    var _b = socketEventsHandlerDelays || {}, handleBetsClosedDelay = _b.handleBetsClosed, handleRoundStartDelay = _b.handleRoundStart, handleDoBetResultDelay = _b.handleDoBetResult, handleResultReportDelay = _b.handleResultReport, handleRoundFinDelay = _b.handleRoundFin;
    var additionalParams = betData.additionalParams, roundData = betData.roundData;
    var maxOdd = Math.max.apply(Math, __spreadArray([], __read(roundData.map(function (item) { return item.odd; })), false));
    var currentBetData = betData;
    setTimeout(function () {
        setTimeout(function () { return handleRoundStart({ data: { startedRound: { roundId: betData === null || betData === void 0 ? void 0 : betData.roundId, duration: 5 } } }); }, handleRoundStartDelay || 400);
        setTimeout(function () {
            handleBetsClosed();
        }, handleBetsClosedDelay || 500);
        setTimeout(function () {
            handleDoBetResult(__assign(__assign({}, betData), { betData: additionalParams, status: BetStatus.Pending, winAmount: 0, responseCode: BetResponseCode.Success }));
        }, handleDoBetResultDelay || 800);
        setTimeout(function () {
            var intervalId = setInterval(function () {
                var _a, _b;
                var crashedItemsInfo = [];
                var odd = toFixed(plus(currentOdd, 0.01), 2);
                var currentItemsInfo = currentBetData.roundData.map(function (item) {
                    var _a, _b;
                    var crashedIndex = (item === null || item === void 0 ? void 0 : item.pigIndex) || (item === null || item === void 0 ? void 0 : item.pigIndex) === 0
                        ? item === null || item === void 0 ? void 0 : item.pigIndex
                        : (item === null || item === void 0 ? void 0 : item.jetIndex) || (item === null || item === void 0 ? void 0 : item.jetIndex) === 0
                            ? item === null || item === void 0 ? void 0 : item.jetIndex
                            : item === null || item === void 0 ? void 0 : item.index;
                    if (+currentOdd >= +(item === null || item === void 0 ? void 0 : item.odd)) {
                        crashedItemsInfo.push({
                            index: crashedIndex,
                            odd: item === null || item === void 0 ? void 0 : item.odd,
                            isSave: true,
                        });
                    }
                    if (+currentOdd === +(betData === null || betData === void 0 ? void 0 : betData.odd)) {
                        handleCashOutResult(__assign(__assign({}, betData), { cashOutHalf: ((_b = (_a = betData === null || betData === void 0 ? void 0 : betData.additionalParams) === null || _a === void 0 ? void 0 : _a.cashOutInfos) === null || _b === void 0 ? void 0 : _b.length) === 2 }));
                    }
                    return __assign(__assign({}, item), { index: crashedIndex, currentOdd: +currentOdd <= +(item === null || item === void 0 ? void 0 : item.odd) ? odd : item === null || item === void 0 ? void 0 : item.odd, isRemove: +currentOdd > +(item === null || item === void 0 ? void 0 : item.odd) });
                });
                if (+currentOdd <= +maxOdd) {
                    handleResultReport({
                        data: {
                            resultReportData: {
                                currentItemsInfo: currentItemsInfo === null || currentItemsInfo === void 0 ? void 0 : currentItemsInfo.filter(function (item) { return !(item === null || item === void 0 ? void 0 : item.isRemove); }),
                                second: 1000,
                                currentOdd: currentOdd,
                                crashedItemsInfo: crashedItemsInfo,
                            },
                            isCrash: +odd >= (+((_a = betData === null || betData === void 0 ? void 0 : betData.roundData) === null || _a === void 0 ? void 0 : _a.odd) || (betData === null || betData === void 0 ? void 0 : betData.roundData)),
                        },
                    });
                    currentBetData = __assign(__assign({}, betData), { roundData: (_b = betData === null || betData === void 0 ? void 0 : betData.roundData) === null || _b === void 0 ? void 0 : _b.filter(function (item) {
                            return +currentOdd < +(item === null || item === void 0 ? void 0 : item.odd);
                        }) });
                    crashedItemsInfo = [];
                    currentOdd = odd;
                }
                else {
                    clearInterval(intervalId);
                    setTimeout(function () {
                        handleRoundFin({
                            data: {
                                finishedRound: { roundData: betData === null || betData === void 0 ? void 0 : betData.roundData },
                                bets: [betData],
                            },
                        });
                    }, handleRoundFinDelay || 0);
                }
            }, 100);
        }, handleResultReportDelay || 1500);
    }, 2500);
};

export { callFakeGameSocketHandlersForBogLineTurboGames, callFakeGameSocketHandlersForCrashGame, callFakeGameSocketHandlersForSeveralTheSameBets, callFakeGameSocketHandlersWithMarketGames, callFakeGameSocketHandlersWithRoundFinAndStart };
